import o, { forwardRef as l, useCallback as y } from "react";
import { ark as p, useTabsContext as f, Tabs as u } from "@ark-ui/react";
import { sidebar as b } from "@huspy/styled-system/recipes";
import { splitCssProps as z } from "@huspy/styled-system/jsx";
import { cx as B, css as w } from "@huspy/styled-system/css";
import { ChevronLeft as I, ChevronRight as L } from "lucide-react";
import { IconButton as h } from "../../../components/icon-button/icon-button.mjs";
import { createStyleContext as V } from "../../../utils/createStyleContext.mjs";
import { useLayoutContext as C } from "../../layout/use-layout.mjs";
const { withProvider: O, withContext: a } = V(b), N = O(p.div, "root"), A = a(
  l((r, s) => {
    const { onClick: e, children: i, ...t } = r, { toggle: n, open: c } = C(), { clearValue: d } = f(), m = y(
      (g) => {
        e == null || e(g), n("sidebar"), d();
      },
      [e, n, d]
    );
    return i ? /* @__PURE__ */ o.createElement(h, { size: "sm", ...t, ref: s, onClick: m }, i) : /* @__PURE__ */ o.createElement(h, { size: "sm", ...t, ref: s, onClick: m }, c === "sidebar" ? /* @__PURE__ */ o.createElement(I, { size: 16 }) : /* @__PURE__ */ o.createElement(L, { size: 16 }));
  }),
  "trigger"
), P = a(
  p.div,
  "group"
), v = a(
  p.hr,
  "separator"
), E = a(
  l((r, s) => {
    const { open: e } = C(), [i, t] = b.splitVariantProps(r), [n, c] = z({ ...t, open: e }), { children: d, className: m, ...g } = c, G = b({ ...i, open: e });
    return /* @__PURE__ */ o.createElement(
      p.div,
      {
        ref: s,
        className: B(G.item, w(n), m),
        "aria-selected": r.selected,
        ...g
      },
      d
    );
  }),
  "item"
), S = a(
  l((r, s) => /* @__PURE__ */ o.createElement(u.Root, { ...r, ref: s, asChild: !0 }, /* @__PURE__ */ o.createElement(o.Fragment, null, r.children))),
  "asideRoot"
), T = a(
  u.List,
  "asideGroup"
), k = a(
  l((r, s) => {
    const { onClick: e, ...i } = r, { setOpen: t } = C(), n = y(
      (c) => {
        e == null || e(c), t("aside");
      },
      [e, t]
    );
    return /* @__PURE__ */ o.createElement(u.Trigger, { ...i, ref: s, onClick: n });
  }),
  "asideTrigger"
), x = a(
  u.Content,
  "asideContent"
), R = a(
  l((r, s) => {
    const { clearValue: e } = f(), { setOpen: i } = C(), { onClick: t, ...n } = r, c = y(
      (d) => {
        t == null || t(d), e(), i("none");
      },
      [t, e, i]
    );
    return /* @__PURE__ */ o.createElement(h, { ...n, ref: s, onClick: c });
  }),
  "asideCloseButton"
);
N.displayName = "Sidebar";
A.displayName = "SidebarTrigger";
P.displayName = "SidebarGroup";
v.displayName = "SidebarSeparator";
E.displayName = "SidebarItem";
S.displayName = "AsideProvider";
T.displayName = "AsideGroup";
k.displayName = "AsideTrigger";
x.displayName = "AsideContent";
R.displayName = "AsideCloseButton";
const U = {
  Root: N,
  Trigger: A,
  Group: P,
  Separator: v,
  Item: E,
  AsideProvider: S,
  AsideGroup: T,
  AsideTrigger: k,
  AsideContent: x,
  AsideCloseButton: R
};
export {
  U as Sidebar
};
